import moment from "moment";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { GetQuizAttemptsService } from "../../../services/QuizService";
import SkeletonContainer, { getSkeletonHeight } from "../../../loaders/SekletonContainer";
import { ContainerWrapper } from "../../common/GlobalElements/Wrappers";
import { TextLink } from "../../common/GlobalElements/Typography";

export default function ViewQuiz(props) {
  const { quizId, setshow, setrId, rId, setlist,list } = props;
  const [quiz, setquiz] = useState({});
  const [maximumLimit, setmaximumLimit] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    GetQuizAttemptsService({ quid: quizId })
      .then((res) => {
        setLoading(false);
        setlist(res.data.data.attempts);
        setquiz(res.data.data.description);
        setmaximumLimit(res.data.data.maximumLimit);
      })
      .catch((err) => {
        setLoading(false);
        setlist([]);
      });
  }, []);

  const date = (value) => {
    const timestamp = new Date(value * 1000);
    return moment(timestamp).format("MM/DD/YYYY h:mm a");
  };

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const secToMin = (value) => {
    var timestamp = value;
    var hours = Math.floor(timestamp / 60 / 60);
    var minutes = Math.floor(timestamp / 60) - hours * 60;
    var seconds = timestamp % 60;
    var formatted =
      minutes.toString().padStart(2, "0") +
      ":" +
      seconds.toString().padStart(2, "0");
    return formatted;
  };
  // quiz result list data table 
  return (
    <>
      <div className="card card-header-transparent">
        {loading ? <SkeletonContainer height={getSkeletonHeight(10)} /> :<ContainerWrapper className="card-body">
          <div className="table-responsive table__quize__desc">
            <table className="table table-bordered">
              <thead className="thead-dark">
                <tr>
                  <th>Attempt</th>
                  <th>Attempt Time</th>
                  <th>Score</th>
                  <th>Time Spent (Min)</th>
                  <th>Percentage (%)</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {list.map((item, index) => (
                  <tr>
                    <td>
                      <TextLink
                        href="javascript:;"
                        onClick={() => {
                          setrId(item?.rid);
                          setshow({attempt: false,
                            review: true});
                        }}
                      >
                        {index + 1}. Attempted Quiz Result
                      </TextLink>
                    </td>
                    <td>{date(item.start_time)}</td>
                    <td>{~~item.score_obtained}</td>
                    <td>{secToMin(item.total_time)}</td>
                    <td>{~~item.percentage_obtained + "%"}</td>
                    <td>{capitalizeFirstLetter(item.result_status)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </ContainerWrapper>}
      </div>
    </>
  );
}
